import {
    LOCALIZATION_SET_SYSTEM_UNIT,
    LOCALIZATION_SET_ACTIVE_LANGUAGE,
    LOCALIZATION_SET_ACTIVE_REGION,
    LOCALIZATION_SET_USERS_REGION_AND_LANGUAGE,
    SWITCH_PRODUCT_TYPE,
    GLOBAL_PROJECT_TYPE_PIPE,
    GLOBAL_PROJECT_TYPE_CHAMBER, PROJECTS_CRUD_RESTORE_STATE, IMPERIAL
} from '../lib/types';

/* All language translations are stored in these json files */
import * as enUS from '../lib/localization/enUS.json';
import * as enGB from '../lib/localization/enGB.json';
import * as frCA from '../lib/localization/frCA.json';
import * as esES from '../lib/localization/esES.json';
import * as frFR from '../lib/localization/frFR.json';
import * as deDE from '../lib/localization/deDE.json';

import { metric } from '../lib/localization/metric';
import { imperial } from '../lib/localization/imperial';
import { regionIds } from '../lib/localization/regionIds';
import { languageIds } from '../lib/localization/languageIds';
import { getRegionById, getActiveRegions } from '../lib/localization/regions';
import { languages, getLanguageById } from '../lib/localization/languages';
import { unitIds } from "../lib/localization/unitIds";

const getChosenRegionAndLang = (projectType = null) => {
    let regionSelected = localStorage.getItem("regionDefined");
    const selectedRegion = getRegionById(regionSelected || regionIds.usa);
    let langId = languageIds.enUS;
    let unitId = IMPERIAL;
    if (regionSelected) {
        langId = localStorage.getItem("languageDefined");
        unitId = localStorage.getItem("unitDefined");
        if (!selectedRegion.languages.find(l => l.id === langId)) {
            langId = selectedRegion.defaultLanguageId;
        }
    }
    if ((projectType || localStorage.getItem('productType')) === GLOBAL_PROJECT_TYPE_PIPE) {
        const defaultRegion = getRegionById(regionIds.usa);
        return {
            selectedRegion: defaultRegion,
            selectedLanguage: getLanguageById(languageIds.enUS),
            selectedUnit: selectedRegion.unitId,
            unit: unitId
        };
    } else {
        return {
            selectedRegion: selectedRegion,
            selectedLanguage: getLanguageById(langId),
            selectedUnit: selectedRegion.unitId,
            unit: unitId
        };
    }
};

const {
    selectedRegion,
    selectedLanguage,
    selectedUnit
} = getChosenRegionAndLang();

const initialState = {
    regionChosenByUser: localStorage.getItem('regionDefined') !== null,
    region: selectedRegion,
    regions: getActiveRegions(),
    language: selectedLanguage,
    languages: languages,
    unit: selectedUnit,
    units: [
        { id: unitIds.imperial, name: unitIds.imperial },
        { id: unitIds.metric, name: unitIds.metric },
    ],
    lang: selectedLanguage.id,
    content: {
        enUS: enUS,
        esES: esES,
        enGB: enGB,
        frCA: frCA,
        frFR: frFR,
        deDE: deDE,
    },
    lbl: {
        metric: metric,
        imperial: imperial
    }
};

export const LocalizationReducer = (state = initialState, action) => {
    switch (action.type) {

        case LOCALIZATION_SET_ACTIVE_REGION:
            let activeRegion = getRegionById(action.payload);
            return {
                ...state,
                region: activeRegion,
                lang: activeRegion.defaultLanguageId,
                language: languages.find(language => {
                    return language.id === activeRegion.defaultLanguageId;
                }),
                unit: activeRegion.unitId,
                regionChosenByUser: true
            };

        case LOCALIZATION_SET_ACTIVE_LANGUAGE:
            return {
                ...state,
                language: languages.find(language => language.id === action.payload),
                lang: action.payload
            };

        case LOCALIZATION_SET_SYSTEM_UNIT:
            return {
                ...state,
                unit: action.payload,
            };

        case LOCALIZATION_SET_USERS_REGION_AND_LANGUAGE:
            // short circuit this if the user is in PIPE
            if (localStorage.getItem("productType") !== GLOBAL_PROJECT_TYPE_CHAMBER) {
                return state;
            }

            let userRegion = getRegionById(action.payload.region);

            let activeLanguage = languages.find(language => {
                return language.id === action.payload.language;
            });

            let activeUnitId = (action.payload.unit !== null) ? action.payload.unit : 'imperial';

            localStorage.setItem('regionDefined', userRegion.id);
            localStorage.setItem('languageDefined', activeLanguage.id);
            localStorage.setItem('unitDefined', activeUnitId);

            return {
                ...state,
                region: userRegion,
                lang: activeLanguage.id,
                language: activeLanguage,
                unit: activeUnitId,
                regionChosenByUser: true
            };

        case SWITCH_PRODUCT_TYPE:
            let selRegion, selLang;
            const userChamberSettings = getChosenRegionAndLang(action.payload.projectType);
            selRegion = userChamberSettings.selectedRegion;
            selLang = userChamberSettings.selectedLanguage;
            return {
                ...state,
                region: selRegion,
                language: selLang,
                lang: selLang.id,
                unit: selRegion.unitId,
            };

        case PROJECTS_CRUD_RESTORE_STATE:
            let rState = action.payload.localization;

            rState = {
                ...rState,
                regions: initialState.regions,
                languages: initialState.languages,
                units: initialState.units,
                content: initialState.content,
                lbl: initialState.lbl,
            };

            if (Object.keys(rState).length >= 2) {
                return {
                    ...state,
                    ...rState
                };
            } else {
                return state;
            }


        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/localization-reducer.js